<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  privateAdjusted: Object,
  publicAdjusted: Object,
  profitAdjusted: Object,
})

onMounted(() => {
  const { privateAdjusted, publicAdjusted, profitAdjusted } = props

  Highcharts.setOptions({
    lang: {
      numericSymbols: ["k", "M", "B", "T", "P", "E"],
    },
    colors: ["#058DC7", "#64E572", "#24CBE5", "#DDDF00", "#24CBE5", "#64E572", "#FF9655", "#FFF263", "#6AF9C4"],
  })

  const series = [
    {
      name: "For-Profit",
      data: Object.values(profitAdjusted),
    },
    {
      name: "Public",
      data: Object.values(publicAdjusted),
    },
    {
      name: "Private",
      data: Object.values(privateAdjusted),
    },
  ]

  new Highcharts.chart("adjusted_tfi", {
    chart: {
      type: "column",
    },
    title: {
      text: "Adjusted Federal Investment",
    },
    xAxis: {
      title: {
        text: "Graduating Class",
      },
      categories: Object.keys(privateAdjusted),
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
      stackLabels: {
        enabled: true,
        formatter() {
          return `$${Highcharts.numberFormat(this.total / 1000000000, 2, ".", ",")} billion`
        },
      },
    },
    tooltip: {
      headerFormat: "<b>{point.x} Adjusted Federal Investment</b><br/>",
      pointFormat: "{series.name} Schools: ${point.y}",
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: false,
          color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || "white",
        },
      },
    },
    series,
  })
})
</script>
